import { Payload, UseCase } from '@smile-next/uikit';
import { createLambdaError } from '@/errors/utils/createLambdaError';

export class DisplayedLambdaErrorMessagePayload extends Payload {
    type = 'DisplayedLambdaErrorMessagePayload';
    constructor(public readonly lambdaErrorMessage?: string) {
        super();
    }
}

export class DisplayLambdaErrorMessageUseCase extends UseCase {
    execute(lambdaErrorCode: string) {
        this.dispatch(new DisplayedLambdaErrorMessagePayload(createLambdaError(lambdaErrorCode).message));
    }
}
